import { render, staticRenderFns } from "./sistemaFinanceiro.vue?vue&type=template&id=530d8b4a&scoped=true&"
import script from "./sistemaFinanceiro.vue?vue&type=script&lang=js&"
export * from "./sistemaFinanceiro.vue?vue&type=script&lang=js&"
import style0 from "./sistemaFinanceiro.vue?vue&type=style&index=0&id=530d8b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d8b4a",
  null
  
)

export default component.exports